import type { Theme } from '@mui/material';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import Waveform from '../../atoms/Waveform';
import { toMMSS } from '../../../utils';

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
  time: {
    width: '12ch',
  },
}));

export interface RecordingPlaybackProps {
  playing: boolean;
  audioFile: Blob;
}

const RecordingPlayback: React.FC<RecordingPlaybackProps> = ({ playing, audioFile }) => {
  const { classes } = useStyles();

  const [timePassed, setTimePassed] = React.useState(0);
  const [duration, setDuration] = React.useState(0);

  return (
    <div className={classes.container}>
      <span className={classes.time}>
        {toMMSS(timePassed)}
        {duration ? `/${toMMSS(duration)}` : ''}
      </span>
      <Waveform
        file={audioFile}
        onTimeUpdate={setTimePassed}
        onDurationChange={setDuration}
        playing={playing}
      />
    </div>
  );
};

export default RecordingPlayback;
